<span class="card-image">
	@if (item().imageUrl) {
		<img [src]="item().imageUrl" [alt]="item().data.sport" />
	}
</span>

<span class="card-name truncate-text">{{ item().label }}</span>
